export const SAVE_MOL2FILE_NAME = 'SAVE_MOL2FILE_NAME'
export const SAVE_CENTER        = 'SAVE_CENTER'
export const SAVE_JOB_NAME      = 'SAVE_JOB_NAME'
export const SAVE_JOB_OPTIONS   = 'SAVE_JOB_OPTIONS'
export const SAVE_CGENFF_VERSION = 'SAVE_CGENFF_VERSION'
export const JOB_FAILED         = 'JOB_FAILED'
export const RESET_JOB          = 'RESET_JOB'
